/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterLanguageKind = (typeof FilterLanguageKind)[keyof typeof FilterLanguageKind];

export const FilterLanguageKind = {
  language: 'language',
} as const;
